import React, { useMemo, Fragment, useEffect } from 'react'
import { map } from 'lodash-es'
import {
    Color,
    WebMapServiceImageryProvider,
    SingleTileImageryProvider,
} from 'cesium'
import {
    ImageryLayer,
    GeoJsonDataSource,
    useCesium
} from 'resium'

const DynamicImageryLayer = ({ name, url }) => {
    const tempProvider = useMemo(() => new WebMapServiceImageryProvider({
        url: url,
        layers: name,
        parameters: {
            service: 'WMS',
            format: 'image/png',
            transparent: true,
        },
    }), [name, url]);
    return (
        <ImageryLayer imageryProvider={tempProvider} show={true} />
    )
}

const SingleImageLayer = ({ url }) => {
    const singleImageProvider = useMemo(() => new SingleTileImageryProvider({ url }), [url])
    return (
        <ImageryLayer imageryProvider={singleImageProvider} show={true} />
    )
}

const WindFieldLayer = ({ name, url }) => {
    const context = useCesium()
    const viewer = context.viewer
    useEffect(() => {
        const panel = {
            particlesTextureSize: 128,
            maxParticles: 128 * 128,
            particleHeight: 100.0,
            fadeOpacity: 0.996,
            dropRate: 0.003,
            dropRateBump: 0.01,
            speedFactor: 4.0,
            lineWidth: 4.0,
            nc: url,
            color: '/geojson/nc/colorTable.json'
        }
        const windField = new window.CesiumPro.WindField(
            viewer,
            panel, {
            debug: false
        });
        return () => {
            if(windField) {
                windField.remove()
            }
        };
    }, [url, viewer]);
    return (
        <Fragment/>
    )
}

const DynamicLayerLoader = ({ layers }) => {
    const cesiumLayers = map(layers, (layer) => {
        const { name, type, url } = layer
        if (type === 'geojson') {
            return (
                <GeoJsonDataSource
                    key={`layer-${name}`}
                    name={name}
                    show={true}
                    data={url}
                    fill={Color.TRANSPARENT}
                    stroke={Color.GOLD}
                    strokeWidth={4}
                />
            )
        } else if (type === 'wms') {
            return (
                <DynamicImageryLayer key={`layer-${name}`} name={name} url={url} />
            )
        } else if (type === 'image') {
            return (
                <SingleImageLayer key={`layer-${name}`} name={name} url={url} />
            )
        } else if (type === 'nc') {
            return <WindFieldLayer key={`layer-${name}`} name={name} url={url} />
        } else {
            return null
        }
    })
    return (
        <Fragment>{cesiumLayers}</Fragment>
    )
}

export default DynamicLayerLoader